// extracted by mini-css-extract-plugin
export default {"searchBox":"by_gT","resultsOpen":"by_gV"};